<template>
  <create-grocery />
</template>

<script setup lang="ts">
import CreateGrocery from '@/components/Main/Operator/Grocery/CreateGrocery.vue';
</script>

<style scoped lang="scss"></style>
